export const dateDDMMYYFormat = (date: string) => {
  let d: Date
  d = new Date(date)
  if (!date || date === 'undefined') {
    d = new Date()
  }
  const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d)
  const mo = new Intl.DateTimeFormat('en', { month: 'long' }).format(d)
  const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d)
  return `${da}th ${mo} ${ye}`
}
